var map = {
	"./Circle.gif": 31358,
	"./MistForest.gif": 11130,
	"./TreeReflection.gif": 56617,
	"./Waterfall.gif": 86660,
	"./butterfly.gif": 8959,
	"./crystal.gif": 86264,
	"./drop.gif": 79577,
	"./windturbines.gif": 46152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11451;